import React, { useEffect, useState } from 'react';
import './style.css'
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Analise from '../../data/Analise';
import Chip from '@material-ui/core/Chip';
import CancelIcon from '@material-ui/icons/Cancel';
import Checkbox from '@material-ui/core/Checkbox';
import FormHelperText from '@material-ui/core/FormHelperText';
import { ParametrosAnalise, MapAnalysesByAmostraTypeAndParametroAnaliseAndSerieAnalise, TiposLimiaresBySerieAnaliseAndIdParametroAnaliseAndIdUnidadeParametroAnalise, LimiaresAmostras, DadosSeriesAnaliseByIdParametroAnaliseComUnidade, GrupoAnaliseSolo } from '../../config/api'
import SecoIcon from "../../assets/explorarIcons/Seco.svg";
import SecoCinzaIcon from "../../assets/explorarIcons/Seco-Cinza.svg";
import ChuvosoIcon from "../../assets/explorarIcons/Chuvoso.svg";
import ChuvosoCinzaIcon from "../../assets/explorarIcons/Chuvoso-Cinza.svg";
import SedimentoIcon from "../../assets/explorarIcons/Sedimento.svg";
import SedimentoCinzaIcon from "../../assets/explorarIcons/Sedimento-Cinza.svg";
import NenhumaIcon from "../../assets/explorarIcons/Nenhuma.svg";
import MicrobaciaIcon from "../../assets/explorarIcons/Microbacia.svg";
import DrenagemIcon from "../../assets/explorarIcons/Drenagem.svg";
import SuperficialIcon from "../../assets/explorarIcons/Superficial.svg";
import SubsuperficialIcon from "../../assets/explorarIcons/Subsuperficial.svg";
import SelectableItem from './SelectableItem';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
//import ReactResizeDetector from 'react-resize-detector';

var tagsLimiares = [];
var inicialLoad = true
var useStyles = makeStyles(theme => ({
    formControl: {
        margin: theme.spacing(2),
    },
    textField: {
        color: "#FFF",
        fontFamily: "sans-serif",
        fontWeight: "bold",
        fontSize: 24,
        '& .MuiInput-underline:before': {
            borderBottomColor: "rgba(255,255,255,0.75)",
        },
        //'& .MuiInput-underline:hover:not($disabled):before': {
         //   borderBottomColor: "rgba(255,255,255,0.75)",
        //},
        '& .MuiInput-underline:after': {
            borderBottomColor: "rgba(255,255,255,0.75)",
        },
        '& .MuiAutocomplete-popupIndicator': {
            color: "rgba(255,255,255,0.6)"
        }
    },
    textFieldLabel: {
        color: "rgba(255,255,255,0.75)",
        fontFamily: "sans-serif",
        fontSize: 16,
        "&.Mui-focused": {
            color: "#FFF"
        }
    },
    textFieldLimiarRoot: {
        '& .MuiAutocomplete-popupIndicator': {
            color: "rgba(226,112,43,0.6)"
        }
    },
    textFieldLimiarFocused: {},
    textFieldLimiarRootNotchedOutline: {
        borderWidth: '1px',
        borderColor: "rgb(226,112,43) !important"
    },
}));

const Explorar = (props) => {
    const [parametro, setParametro] = useState()
    const [parametros, setParametros] = useState()
    const [optionsParametros, setOptionsParametros] = useState([])
    const [serie, setSerie] = useState()
    const [seriesHabilitadas, setSeriesHabilitadas] = useState([])
    const [representacao, setRepresentacao] = useState('0')
    const [limiares, setLimiares] = useState([])
    const [optionsLimiares, setOptionsLimiares] = useState([])
    const [open, setOpen] = useState(false)
    const [isSedimento, setSedimento] = useState(false)
    const [contrastar, setContrastar] = useState(false)
    //TODO: Precisa verificar a criação dessa constante
    const loading = (inicialLoad || open) && optionsParametros.length === 0
    //Deve ser assim: const loading = (inicialLoad || open) && optionsParametros.length === 0
    //Ou assim: const loading = inicialLoad || (open && optionsParametros.length === 0)
    const [fakeChange, setFakeChange] = useState(true)

    const classes = useStyles();

    useEffect(() => {
        let active = true;
        if (!loading && !sessionStorage.getItem('logado')) {
            inicialLoad = true
            return
        }

        (async () => {
            const parametros = await ParametrosAnalise()
            if (!parametros) {
                setOpen(false)
                return
            }
            setParametros(parametros)

            if (active) {
                const parametrosNomes = parametros.map(p => p.nome)
                setOptionsParametros(parametrosNomes.filter((p, i) => parametrosNomes.indexOf(p) === i));
            }

        })();

        return () => {
            active = false;
        };
    }, [loading]);

    useEffect(() => {
        if (!parametros) return
        changeParametro('Ferro')
        inicialLoad = false
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [parametros])

    useEffect(() => {
        if (!parametro) {
            tagsLimiares = []
            props.setLimiar([])
            return
        }

        (async () => {
            const dadosSerie = await DadosSeriesAnaliseByIdParametroAnaliseComUnidade(parametro.id)
            setSeriesHabilitadas(dadosSerie)

            const idSerieSelecionada = serie && dadosSerie.find(ds => ds.serie === serie.serie) ? serie.serie : ["100", "110", "ts", "sp", "ss"].find(s => dadosSerie.find(ds => ds.serie === s))
            const serieSelecionada = dadosSerie.filter(ds => ds.serie === idSerieSelecionada)[0]
            setSerie(serieSelecionada)

            loadComboLimiares(parametro.id, serieSelecionada)
            loadLimiarAmostras()
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [parametro])

    useEffect(() => {
        if (!parametro) return

        if (serie.serie === 'ss' || serie.serie === 'sp') {
            props.carregarSolo({parametro: parametro, serie: serie.serie, contrastar: contrastar})
        } else {
            if (representacao === "-1") {
                props.dadosAnalise()
                props.cleanLegendaAnalise()
            } else {
               carregarAnalise(parametro.id, serie)
            }
        }
        
        loadComboLimiares(parametro.id, serie)
        loadLimiarAmostras()

        setDadosExternos()

        if (serie.serie === 'ts') {
            setSedimento(true)
            setContrastar(false)
        } else {
            setSedimento(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [serie, contrastar])

    useEffect(() => {
        if (!parametro) return
        if (!serie) return
        if (!limiares || limiares.length === 0) {
            tagsLimiares = []
            props.setLimiar([])
            props.setTipoLimiarSelecionado([])
            return
        }
        props.setTipoLimiarSelecionado(limiares)
        loadLimiarAmostras()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [limiares])

    const loadComboLimiares = async (parametroId, serie) => {
        if (!serie) {
            setOptionsLimiares([])
            return
        }
        const opcoesLimiares = await TiposLimiaresBySerieAnaliseAndIdParametroAnaliseAndIdUnidadeParametroAnalise(parametroId, serie.serie, serie.idUnidade)
        setOptionsLimiares(opcoesLimiares)
    }

    useEffect(() => {
        setDadosExternos()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [representacao])

    const loadLimiarAmostras = async () => {
        if (!serie) return

        let limiaresSelecionados = null;
        if (!limiares || limiares.length === 0) {
            if (!tagsLimiares || tagsLimiares.length === 0) {
                return
            } else {
                limiaresSelecionados = tagsLimiares
            }
        } else {
            limiaresSelecionados = limiares
        }

        const limiaresAmostras = await LimiaresAmostras(parametro.id, serie.serie, serie.idUnidade, limiaresSelecionados)
        props.setLimiar(limiaresAmostras)
    }

    const changeParametro = (parametro) => {
        setOptionsLimiares([])

        if (parametro) {
            const objParametro = parametros.filter(p => p.nome === parametro)[0]
            console.log("objParametro: ", objParametro)
            setParametro(objParametro)
            console.log("Chama Analise.getInstance() componentes/explorar/index.js")
            Analise.getInstance().setParametro(objParametro)
        }
        else clearForm()
    }

    const changeSerie = (idSerie) => {
        const serie = seriesHabilitadas.filter(sh => sh.serie === idSerie)[0]
        setSerie(serie)
    }

    const changeRepresentacao = (representacao) => {
        setRepresentacao(representacao)
        if (!parametro) return
        if (representacao === "-1") {
            props.dadosAnalise()
            props.cleanLegendaAnalise()
        } else {
            carregarAnalise(parametro.id, serie)
        }
    }

    const setDadosExternos = () => {
        console.log("Dados externos")
        console.log("parametro: ", parametro)
        if (!parametro){ 
            console.log("Parametro vazio============================")
            return
        }
        const parametroComUnidade = parametros.filter(p => p.nome === (parametro.nome || parametro) && p.idTipoAmostra === serie.tipoAmostra)[0]
        console.log("parametroComUnidade: ", parametroComUnidade)
        console.log("Chama Analise.getInstance() componentes/explorar/index.js")
        Analise.getInstance().setParametro(parametroComUnidade)
        props.setParametroSerie({ parametro: parametroComUnidade, serie: serie, seriesHabilitadas: seriesHabilitadas, representacao, contrastar })
    }

    const carregarAnalise = async (parametroId, serieObj) => {
        if (!parametroId || !serieObj) return
        let analise
        if (serieObj.serie === 'sp' || serieObj.serie === 'ss') {
            analise = { grupos: await GrupoAnaliseSolo(parametroId, serieObj.serie), itensPorIdFeature: null };
        } else {
            analise = await MapAnalysesByAmostraTypeAndParametroAnaliseAndSerieAnalise(parametroId, serieObj.serie, serieObj.serie === 'ts' ? false : contrastar)
        }
        props.dadosAnalise(analise)
    }

    const clearForm = () => {
        props.clear()
        setSerie()
        setSeriesHabilitadas([])
        setParametro()
        setLimiares([])
    }

    const isChecked = (valor) => {
        if (!serie) return
        return valor === serie.serie
    }

    const isDiseble = (idSerie) => {
        return seriesHabilitadas.length > 0 ? !seriesHabilitadas.find(sh => sh.serie === idSerie) : true
    }

    const limiaresSelecionadosTags = (values, { className, onDelete }) => {
        let opcoes = values

        const intersecaoLimiares = opcoes.filter(opcao => optionsLimiares.filter(ol => ol.id === opcao.id).length > 0)
        if (intersecaoLimiares.length > 0)
            opcoes = intersecaoLimiares
        else
            return

        const itens = opcoes.map((option, index) => (
            <Chip
                key={index}
                className={className}
                data-tag-index={index}
                style={{ backgroundColor: 'rgb(226,112,43)', color: "#FFF" }}
                deleteIcon={(
                    <CancelIcon
                        style={{ color: "rgba(255,255,255,0.6)" }}
                        data-tag-index={index}
                    />
                )}
                label={option.nome}
                onDelete={(event) => {
                    const deletado = tagsLimiares[event.currentTarget.getAttribute('data-tag-index')]
                    tagsLimiares = tagsLimiares.filter(tag => tag !== deletado)
                    onDelete(event)
                }}
                tabIndex={-1}
            />
        ))
        tagsLimiares = opcoes
        return itens
    }

    const filterOptions = (options, state) => {
        return options.filter(o => !tagsLimiares.find(tag => tag.id === o.id))
    }

    return (
        <div id="divExplorar">
            <div
                style={{
                    backgroundColor: "#0b7e7a",
                    marginLeft: -10,
                    marginRight: -10,
                    marginTop: -10,
                    paddingBottom: 8,
                    paddingRight: 16,
                    paddingLeft: 16,
                    display: "flex",
                    flexDirection: "column"
                }}
            >
                <div style={{ display: "flex", flex: 1, flexDirection: "row" }}>
                    <Autocomplete
                        options={optionsParametros}
                        clearOnEscape
                        autoComplete
                        includeInputInList
                        disableClearable
                        open={open}
                        onOpen={() => setOpen(true)}
                        onClose={() => setOpen(false)}
                        onChange={(event, obj) => changeParametro(obj)}
                        getOptionLabel={option => option && option}
                        loading={loading}
                        value={parametro}
                        defaultValue={'Ferro'}
                        style={{ flex: 1 }}
                        renderInput={params => (
                            <TextField
                                variant="standard"
                                margin="normal"
                                label="Parâmetro"
                                fullWidth
                                className={classes.textField}
                                {...params}
                                style={{ marginTop: 8 }}
                                InputLabelProps={{
                                    className: classes.textFieldLabel
                                }}
                                InputProps={{
                                    ...params.InputProps,
                                    classes: {
                                        root: classes.textField,
                                    },
                                    endAdornment: (
                                        <React.Fragment>
                                            {loading && <CircularProgress color="inherit" size={20} />}
                                            {params.InputProps.endAdornment}
                                        </React.Fragment>
                                    ),
                                }}
                            />
                        )}
                    />

                    {parametro &&
                        parametro.formula !== null &&
                        (
                            <div
                                className="divFormulaWrapper"
                                onClick={() => {
                                    props.visualizarDocumentoId({ parametroid: parametro.id, fakeChange })
                                    setFakeChange(!fakeChange)
                                }}
                                style={{
                                    flex: 0.25,
                                    marginLeft: 16,
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}>
                                    <div
                                        className="divFormula"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            border: "solid #FFF",
                                            borderWidth: 2,
                                            borderRadius: 6,
                                            minHeight: 55,
                                            minWidth: 55
                                        }}
                                    >
                                        <label
                                            className="divFormulaWrapper"
                                            style={{
                                                color: "#FFF",
                                                fontFamily: "sans-serif",
                                                fontWeight: "bold",
                                                fontSize: 28,
                                                paddingLeft: 10,
                                                paddingRight: 10
                                            }}>
                                            {parametro.formula}
                                        </label>
                                    </div>
                                </div>
                                <MoreHorizIcon
                                    style={{ color: "#FFF", marginBottom: -5, marginTop: -4 }}
                                />
                            </div>
                        )
                    }
                </div>

                {/* <div style={{ alignSelf: "center" }}>
                    <div className="divBtnInformacoes">
                        <a
                            style={{ color: "#FFF", fontFamily: "sans-serif" }}
                            onClick={() => props.visualizarDocumentoId(parametro.id)}
                        >
                            Informações
                        </a>
                    </div>
                </div> */}

            </div>

            <div>
                {/* <FormControl component="fieldset" className={classes.formControl}>
                    <FormLabel component="legend">Série</FormLabel>
                    <RadioGroup onChange={(event) => changeSerie(event.target.value)}>
                        <FormControlLabel value="100" control={<Radio color="default" checked={isChecked('100')} />} label="Chuvoso" disabled={isDiseble('100')} />
                        <FormControlLabel value="110" control={<Radio color="default" checked={isChecked('110')} />} label="Seco" disabled={isDiseble('110')} />
                        <FormControlLabel value="ts" control={<Radio color="default" checked={isChecked('ts')} />} label="Sedimento" disabled={isDiseble('ts')} />
                    </RadioGroup>
                </FormControl> */}

                <div style={{ marginTop: 16, flexDirection: "column", display: "flex" }}>
                    <label style={{ fontFamily: "sans-serif", fontWeight: "lighter", color: "#000", marginBottom: 14, fontSize: 12, alignSelf: "center" }}>Meio Amostral</label>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                        <div
                            style={{
                                borderBottom: "solid rgb(215,215,215)",
                                borderLeft: "solid rgb(215,215,215)",
                                borderRight: "solid rgb(215,215,215)",
                                borderWidth: 1,
                                borderRadius: 4,
                                display: "table",
                                position: "relative",
                                flex: 0.6
                            }}>
                            <div style={{ display: "flex", flexDirection: "row", marginBottom: -10 }}>
                                <div style={{ width: 8, height: 1, borderTopLeftRadius: 4, borderTop: "solid 1px rgb(215,215,215)" }} />
                                <div style={{ marginTop: -8 }}>
                                    <label
                                        style={{
                                            fontFamily: "sans-serif",
                                            fontWeight: "lighter",
                                            color: "rgba(0, 0, 0, 0.5)",
                                            paddingLeft: 6,
                                            paddingRight: 6
                                        }}>Água Superficial</label>
                                </div>
                                <div style={{ flex: 1, height: 1, borderTopRightRadius: 4, borderTop: "solid 1px rgb(215,215,215)" }} />
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    flex: 1,
                                    justifyContent: "space-around",
                                    paddingTop: 20,
                                    paddingLeft: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                }}>
                                <SelectableItem
                                    label={"Chuvoso"}
                                    icon={ChuvosoIcon}
                                    notEnabledIcon={ChuvosoCinzaIcon}
                                    isSelected={isChecked('100')}
                                    isDisabled={isDiseble('100')}
                                    onClick={() => {
                                        if (!isDiseble('100')) {
                                            changeSerie("100")
                                        }
                                    }}
                                />
                                <SelectableItem
                                    label={"Seco"}
                                    icon={SecoIcon}
                                    notEnabledIcon={SecoCinzaIcon}
                                    isSelected={isChecked('110')}
                                    isDisabled={isDiseble('110')}
                                    onClick={() => {
                                        if (!isDiseble('110')) {
                                            changeSerie("110")
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        <div style={{ display: "flex", flex: 0.4, alignItems: "center", justifyContent: "center", paddingTop: 16, paddingBottom: 8 }}>
                            <SelectableItem
                                label={"Sedimento"}
                                icon={SedimentoIcon}
                                notEnabledIcon={SedimentoCinzaIcon}
                                size={60}
                                isSelected={isChecked('ts')}
                                isDisabled={isDiseble('ts')}
                                onClick={() => {
                                    if (!isDiseble('ts')) {
                                        changeSerie("ts")
                                    }
                                }}
                            />
                        </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                        <div
                            style={{
                                borderBottom: "solid rgb(215,215,215)",
                                borderLeft: "solid rgb(215,215,215)",
                                borderRight: "solid rgb(215,215,215)",
                                borderWidth: 1,
                                borderRadius: 4,
                                marginTop: 20,
                                display: "table",
                                position: "relative",
                                flex: 1
                            }}>
                            <div style={{ display: "flex", flexDirection: "row", marginBottom: -10 }}>
                                <div style={{ width: 8, height: 1, borderTopLeftRadius: 4, borderTop: "solid 1px rgb(215,215,215)" }} />
                                <div style={{ marginTop: -8 }}>
                                    <label
                                        style={{
                                            fontFamily: "sans-serif",
                                            fontWeight: "lighter",
                                            color: "rgba(0, 0, 0, 0.5)",
                                            paddingLeft: 6,
                                            paddingRight: 6
                                        }}>Solo</label>
                                </div>
                                <div style={{ flex: 1, height: 1, borderTopRightRadius: 4, borderTop: "solid 1px rgb(215,215,215)" }} />
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    flex: 1,
                                    justifyContent: "space-around",
                                    paddingTop: 20,
                                    paddingLeft: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                }}>
                                <SelectableItem
                                    label={"Superficial"}
                                    icon={SuperficialIcon}
                                    notEnabledIcon={SuperficialIcon}
                                    isSelected={isChecked('ss')}
                                    isDisabled={isDiseble('ss')}
                                    size={45}
                                    width={110}
                                    onClick={() => {
                                        if (!isDiseble('ss')) {
                                            changeSerie("ss")
                                        }
                                    }}
                                />
                                <SelectableItem
                                    label={"Subsuperficial"}
                                    icon={SubsuperficialIcon}
                                    notEnabledIcon={SubsuperficialIcon}
                                    isSelected={isChecked('sp')}
                                    isDisabled={isDiseble('sp')}
                                    size={45}
                                    width={110}
                                    onClick={() => {
                                        if (!isDiseble('sp')) {
                                            changeSerie("sp")
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* <FormControl component="fieldset" className={classes.formControl}>
                    <FormLabel component="legend">Representação</FormLabel>
                    <RadioGroup onChange={(event) => changeRepresentacao(event.target.value)}>
                        <FormControlLabel value="-1" control={<Radio color="default" checked={representacao === '-1'} />} label="Sem representação" />
                        <FormControlLabel value="0" control={<Radio color="default" checked={representacao === '0'} />} label="Microbacia" />
                        <FormControlLabel value="1" control={<Radio color="default" checked={representacao === '1'} />} label="Drenagem" />
                    </RadioGroup>
                </FormControl> */}

                {serie && serie.serie !== 'sp' && serie.serie !== 'ss' ? 
                    <div style={{ marginTop: 24, flexDirection: "column", display: "flex" }}>
                        <label style={{ fontFamily: "sans-serif", fontWeight: "lighter", color: "#000", fontSize: 12, alignSelf: "center" }}>Representação</label>
                        <div style={{ display: "flex", flexDirection: "row", paddingTop: 8, paddingLeft: 16, paddingRight: 16, justifyContent: "space-around" }}>
                            <SelectableItem
                                label={"Microbacia"}
                                icon={MicrobaciaIcon}
                                size={45}
                                isSelected={representacao === '0'}
                                isDisabled={false}
                                onClick={() => changeRepresentacao('0')}
                            />
                            <SelectableItem
                                label={"Drenagem"}
                                icon={DrenagemIcon}
                                size={45}
                                isSelected={representacao === '1'}
                                isDisabled={false}
                                onClick={() => changeRepresentacao('1')}
                            />
                            <SelectableItem
                                label={"Nenhuma"}
                                icon={NenhumaIcon}
                                size={45}
                                isSelected={representacao === '-1'}
                                isDisabled={false}
                                onClick={() => changeRepresentacao('-1')}
                            />
                        </div>
                    </div>
                    :
                    ""
                }
                {!isSedimento &&
                    <div style={{ marginLeft: 20 }}>
                        <FormControl style={{ alignSelf: "center", marginBottom: 16 }} component="fieldset" >
                            <FormControlLabel
                                disabled={isSedimento}
                                control={
                                    <Checkbox
                                        onChange={(event, value) => setContrastar(value)}
                                        color="default"
                                        value={contrastar}
                                        inputProps={{
                                            'aria-label': 'checkbox with default color',
                                        }}
                                    />
                                }
                                label={
                                    <label style={{ fontFamily: "sans-serif", fontSize: 14 }}>Contrastar</label>
                                }
                            />
                            <FormHelperText style={{ marginTop: -5, marginLeft: 31 }}>{serie && (serie.serie === 'sp' || serie.serie === 'ss' ? 'Superficial / Subsuperficial' : (serie.serie === '100' ? 'Período seco - Período chuvoso' : 'Período chuvoso - Período seco'))}</FormHelperText>
                        </FormControl>
                    </div>
                }
            </div>

            <div style={{ marginTop: 18, flexDirection: "column", display: "flex" }}>
                {/* <label style={{ fontFamily: "sans-serif", fontWeight: "lighter", color: "#000", fontSize: 12, alignSelf: "center", marginBottom: 16 }}>Limiares</label> */}
                <Autocomplete
                    style={{ marginLeft: 15, marginRight: 15 }}
                    multiple
                    disableClearable
                    options={optionsLimiares}
                    filterOptions={filterOptions}
                    getOptionLabel={option => option && option.nome}
                    onChange={(event, limiares) => setLimiares(limiares)}
                    renderTags={limiaresSelecionadosTags}
                    renderInput={params => (
                        <TextField
                            {...params}
                            autoComplete="false"
                            placeholder="Selecionar limiar..."
                            variant="outlined"
                            fullWidth
                            InputProps={{
                                ...params.InputProps,
                                classes: {
                                    root: classes.textFieldLimiarRoot,
                                    focused: classes.textFieldLimiarFocused,
                                    notchedOutline: classes.textFieldLimiarRootNotchedOutline,
                                },
                                endAdornment: (
                                    <React.Fragment>
                                        {params.InputProps.endAdornment}
                                    </React.Fragment>
                                ),
                            }}
                        />
                    )}
                />
            </div>
            {/*Comentado para evitar o redimensionamento errado do menu após clicar nas diferentes opções do menu
            <ReactResizeDetector
                handleWidth
                handleHeight
                onResize={(width, height) =>
                    props.size({ width: width + 20, height: height + 50 })
                } />
                */}
        </div>
    );
}

export default Explorar